import { Component } from '@angular/core';
import { Events, IonicPage, NavController, NavParams, ToastController, ViewController } from 'ionic-angular';
import { ComponentServiceProvider } from '../../providers/component-service/component-service';
import { ExportServiceProvider } from '../../providers/export-service/export-service';
import { PriceListTableProvider } from '../../providers/price-list-table/price-list-table';
import { ConfigApiServiceProvider } from '../../providers/config-api-service/config-api-service';
import { DataServiceProvider } from '../../providers/data-service/data-service';

@IonicPage()
@Component({
  selector: 'page-modal-popup',
  templateUrl: 'modal-popup.html',
})
export class ModalPopupPage {

  inputPages: any = '';
  inputData: any = 'All';
  action: any;
  table_name: any = '';
  insertData: any;
  chartIdx: any = 0;
  tabTemplates: any = [];
  importFile: any;
  file: any;
  JsonData: any;
  rowIndex: any;
  newSWItem = {
    "item": "",
    "defCostCdn": "",
    "orPercent": "",
    "newCostCdn": "",
    "SellValue": "",
    "OrPercentStatus": "false"
  }
  cloud_server_name: any = '';
  defCost: any = '';
  dattoDefBase: any = '';
  dattoSizeName: any = '';
  dattoDefMonthly: any = '';
  intronisName: any = '';
  intronisDefUsd: any = '';
  itUserCdn: any = '';
  itName: any = '';
  itDeviceCdn: any = '';
  itCdnBasePrice: any = '';
  showUserCdn: boolean = false;
  showDeviceCdn: boolean = false;
  showCyberCdn: boolean = false;
  showCyberUsd: boolean = false;
  showCyberUserUsd: boolean = false;
  showCyberDeviceUsd: boolean = false;
  showCyberBasepriceUsd: boolean = false;
  showCyberBasepriceCdn: boolean = false;
  showCyberDeviceCdn: boolean = false;
  showCyberUserCdn: boolean = false;
  cyberBasepriceCdn: any = '';
  cyberDeviceCdn: any = '';
  cyberUserCdn: any = '';
  cyberbasepriceUsd: any = '';
  cyberDeviceUsd: any = '';
  cyberUserUsd: any = '';
  cyberName: any = '';
  showAdditionalUsd: boolean = false;
  showAdditionalCdn: boolean = false;
  showAdditionalUserUsd: boolean = false;
  showAdditionalDeviceUsd: boolean = false;
  showAdditionalBasepriceUsd: boolean = false;
  showAdditionalBasepriceCdn: boolean = false;
  showAdditionalUserCdn: boolean = false;
  showAdditionalDeviceCdn: boolean = false;
  additionalUserUsd: any = '';
  additionalDeviceUsd: any = '';
  additionalbasepriceUsd: any = '';
  additionalBasepriceCdn: any = '';
  additionalUserCdn: any = '';
  additionalDeviceCdn: any = '';
  additionalName: any = '';
  listOfContracts: any = [];
  listOfPricelist: any = [];
  itDescription: any = '';
  cyberDescription: any= '';
  additionalDescription: any = '';
  showLoading: boolean = false;
  MsaMaster: any = [];
  SowMaster: any = [];
  constructor(public dataService: DataServiceProvider,public configApiService: ConfigApiServiceProvider, public priceListTableService: PriceListTableProvider, public toastController: ToastController, public exportService: ExportServiceProvider, public events: Events, private viewCtrl: ViewController, public navCtrl: NavController, public navParams: NavParams, public componentService: ComponentServiceProvider) {
    this.tabTemplates = this.componentService.tabTemplates[0];
  }

  ngOnInit() {
    this.action = this.navParams.get('name');
    this.table_name = this.navParams.get('tableName');
    if(this.action == 'LoadContract'){
      this.showLoading = true;
      this.getContract();
    }
    this.initMsaMaster();
    this.initSowMaster();
  }
  initSowMaster(){
    const ids = this.configApiService.sowMaster.map(o => o.uniqueId);
      this.SowMaster = this.configApiService.sowMaster.filter(({ uniqueId }, index) => !ids.includes(uniqueId, index + 1));
  }
  initMsaMaster(){
    const ids = this.configApiService.msaMaster.map(o => o.uniqueId);
      this.MsaMaster = this.configApiService.msaMaster.filter(({ uniqueId }, index) => !ids.includes(uniqueId, index + 1));
  }
  onMerge() {
    if (this.inputData.toLowerCase() == 'all') {
      // this.events.publish("previewAllPages", true);
    } else {
      var pageIndex = this.inputData.match(/[0-9]/g);
      // this.events.publish("previewMergePages", pageIndex);
    }
    this.viewCtrl.dismiss({
    })
    this.inputData = ''
  }

  onInsert() {
    let obj = {
      "id": this.tabTemplates.templates.length.toString(),
      "templateName": this.tabTemplates.templates.length.toString(),
      "componentName": this.insertData,
    }
    this.tabTemplates.templates.splice(this.inputPages - 1, 0, obj);
    this.viewCtrl.dismiss({
    })
    this.inputPages = ''
    this.insertData = ''
    // this.events.publish('refreshData', true);
  }
  onDelete() {
    var pageIndex = this.inputPages.split(',');
    pageIndex.forEach(element => {
      this.tabTemplates.templates.splice(element - 1, 1);
    });
    this.viewCtrl.dismiss({
    });
    this.inputPages = ''
    // this.events.publish('refreshData', true);
  }
  onFileSelected(event) {
    let ImportFile = event.target.files[0].name;
    this.importFile = ImportFile;
    const reader = new FileReader();
    reader.addEventListener('load', () => {
      let uploaded_image = reader.result;
    });
    reader.readAsDataURL(event.target.files[0]);
  }

  getContract() {
    let obj = {"start":1,"end":1000,"userid":3280,"rptname":"contract_file_12095","client":"starport1294"}
    let objData = {data : JSON.stringify(obj)}
    this.configApiService.getContractList(objData).subscribe((respdata: any) => {
      if (respdata["_POST_SummaryMethodResult"].length > 0) {
        if (respdata["_POST_SummaryMethodResult"] !== "FAIL") {
          this.listOfContracts = JSON.parse(respdata["_POST_SummaryMethodResult"]);
          this.showLoading = false;
          this.getPriceList();
        } 
      }
    });
  }
  getPriceList() {
    let obj = {"start":1,"end":1000,"userid":3280,"rptname":"Pricelist_Entry_12528","client":"starport1294"}
    let objData = {data : JSON.stringify(obj)}
    this.configApiService.getContractList(objData).subscribe((respdata: any) => {
      if (respdata["_POST_SummaryMethodResult"].length > 0) {
        if (respdata["_POST_SummaryMethodResult"] !== "FAIL") {
          this.listOfPricelist = JSON.parse(respdata["_POST_SummaryMethodResult"]);
        } 
      }
    });
  }


  filechanged(e) {
    if (e.target.files[0].type == "application/json") {
      let ImportFile = e.target.files[0].name;
      this.importFile = ImportFile;
      this.file = e.target.files[0];
    } else {
      const toast = this.toastController.create({
        message: 'Upload only JSON File',
        duration: 1000,
      });
      toast.present();
    }
  }
  onSubmit() {
    if (this.file) {
      let fileReader = new FileReader();
      fileReader.onload = (e) => {
        this.JsonData = fileReader.result;
        this.viewCtrl.dismiss(JSON.parse(this.JsonData));
      };
      fileReader.readAsText(this.file);
      this.importFile = ''
    }
    else {
      const toast = this.toastController.create({
        message: 'Upload only JSON File',
        duration: 1000,
      });
      toast.present();
    }
  }
  addRow(tableName) {
    if (tableName == 'CLOUD_SERVER') {
      if (this.cloud_server_name != '' && this.defCost != '') {
        let obj = JSON.stringify(this.priceListTableService.priceList.CloudServerAndSW.newSWItem);
        let data = JSON.parse(obj);
        data.item = this.cloud_server_name;
        data.defCostCdn = this.defCost;
        data.SellValue = this.defCost;
        this.priceListTableService.priceList.CloudServerAndSW.SWItem.push(data);
        this.viewCtrl.dismiss();
        this.defCost = '';
        this.cloud_server_name = '';
      } else {
        const toast = this.toastController.create({
          message: 'Please Enter the Value',
          duration: 1000,
        });
        toast.present();
      }
    } else if (tableName == 'DATTO') {
      if (this.dattoSizeName != '' && this.dattoDefBase != '' && this.dattoDefMonthly != '') {
        let obj = JSON.stringify(this.priceListTableService.priceList.Datto.newDattoSize);
        let data = JSON.parse(obj);
        data.device = this.dattoSizeName;
        data.defBaseCost = this.dattoDefBase;
        data.defMonthlyCost = this.dattoDefMonthly;
        data.monthlyPrice = this.dattoDefMonthly;
        data.basePrice = this.dattoDefBase;
        this.priceListTableService.priceList.Datto.DattoSize.push(data);
        this.viewCtrl.dismiss();
        this.dattoSizeName = '';
        this.dattoDefBase = '';
        this.dattoDefMonthly = '';
      } else {
        const toast = this.toastController.create({
          message: 'Please Enter the Value',
          duration: 1000,
        });
        toast.present();
      }
    } else if (tableName == 'INTRONIS') {
      if (this.intronisName != '' && this.intronisDefUsd != '') {
        let obj = JSON.stringify(this.priceListTableService.priceList.newIntronis);
        let data = JSON.parse(obj);
        data.device = this.intronisName;
        data.defUsd = this.intronisDefUsd;
        var cdn = (parseFloat(this.intronisDefUsd.slice(1).replace(/  |,/gi,"")) * (1 + (parseFloat(this.priceListTableService.priceList.TotalUsExchange.slice(0, -1)) / 100)))
        data.cdn = '$' + cdn.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        data.monthlyPrice = '$' + (cdn * (1 + (parseFloat(this.priceListTableService.priceList.TotalToolsMarkup.slice(0, -1)) / 100))).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        this.priceListTableService.priceList.Intronis.push(data);
        this.viewCtrl.dismiss();
        this.intronisName = '';
        this.intronisDefUsd = '';
      } else {
        const toast = this.toastController.create({
          message: 'Please Enter the Value',
          duration: 1000,
        });
        toast.present();
      }
    } else if (tableName == 'IT') {
      if (this.itName != '' && this.itCdnBasePrice != '' && this.itUserCdn != '' || this.itDeviceCdn != '') {
        let obj = JSON.stringify(this.priceListTableService.priceList.newItManagementTools);
        let data = JSON.parse(obj);
        data.id = this.itName.replace(/^\s+|\s+$/gm, '_');
        data.name = this.itName;
        data.cdnCost.basePrice = this.itCdnBasePrice;
        data.cdnCost.user = this.itUserCdn;
        data.cdnCost.device = this.itDeviceCdn;
        data.description = this.itDescription;
        data.cdnCost.IsUser = this.itUserCdn != '' ? 'YES' : 'NO';
        data.cdnCost.IsDevice = this.itDeviceCdn != '' ? 'YES' : 'NO';
        var markupTool = 1 + parseInt(this.priceListTableService.priceList.TotalToolsMarkup != '' ? this.priceListTableService.priceList.TotalToolsMarkup.slice(0, -1) : '0') / 100;
        data.CdnMarkedUpSellingPrice.basePrice = '$' + (parseFloat(data.cdnCost.basePrice != '' ? data.cdnCost.basePrice.slice(1).replace(/  |,/gi,"") : '0') * markupTool).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        data.CdnMarkedUpSellingPrice.user = '$' + (parseFloat(data.cdnCost.user != '' ? data.cdnCost.user.slice(1).replace(/  |,/gi,"") : '0') * markupTool).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        data.CdnMarkedUpSellingPrice.device = '$' + (parseFloat(data.cdnCost.device != '' ? data.cdnCost.device.slice(1).replace(/  |,/gi,"") : '0') * markupTool).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        this.priceListTableService.priceList.ItManagementTools.push(data);
        this.viewCtrl.dismiss();
        this.intronisName = '';
        this.intronisDefUsd = '';
        this.itUserCdn = '';
        this.itDeviceCdn = '';
        this.itDescription = ''
      } else {
        const toast = this.toastController.create({
          message: 'Please Enter the Value',
          duration: 1000,
        });
        toast.present();
      }
    } else if (tableName == 'CYBER') {
      // if(this.cloud_server_name != '' && this.defCost != ''){
      var markupTool = 1 + parseInt(this.priceListTableService.priceList.TotalToolsMarkup != '' ? this.priceListTableService.priceList.TotalToolsMarkup.slice(0, -1) : '0') / 100;
      let obj = JSON.stringify(this.priceListTableService.priceList.newCyberTools);
      var data = JSON.parse(obj);
      data.name = this.cyberName;
      data.description = this.cyberDescription;
      if (this.showCyberUsd == true) {
        if (this.showCyberUserUsd == true) {
          if (this.cyberUserUsd != '') {
            data.Usd.user = this.cyberUserUsd;
            let cdnUser = (parseFloat(data.Usd.user.slice(1).replace(/  |,/gi,"")) * (1 + (parseFloat(this.priceListTableService.priceList.TotalUsExchange.slice(0, -1)) / 100)));
            data.cdnCost.user = '$' + cdnUser.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
          } else {
            data.Usd.user = '';
            data.cdnCost.user = '';
            data.CdnMarkedUpSellingPrice.user = '';
          }
        } else if (this.showCyberBasepriceUsd == true) {
          if (this.cyberbasepriceUsd != '') {
            data.Usd.basePrice = this.cyberbasepriceUsd;
            let cdnBaseprice = (parseFloat(data.Usd.basePrice.slice(1).replace(/  |,/gi,"")) * (1 + (parseFloat(this.priceListTableService.priceList.TotalUsExchange.slice(0, -1)) / 100)));
            data.cdnCost.basePrice = '$' + cdnBaseprice.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
          } else {
            data.cdnCost.basePrice = '';
            data.CdnMarkedUpSellingPrice.basePrice = '';
          }
        } else if (this.showCyberDeviceUsd == true) {
          if (this.cyberDeviceUsd != '') {
            data.Usd.device = this.cyberDeviceUsd;
            let cdnDevice = (parseFloat(data.Usd.device.slice(1).replace(/  |,/gi,"")) * (1 + (parseFloat(this.priceListTableService.priceList.TotalUsExchange.slice(0, -1)) / 100)));
            data.cdnCost.device = '$' + cdnDevice.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
          } else {
            data.Usd.device = '';
            data.cdnCost.device = '';
            data.CdnMarkedUpSellingPrice.device = '';
          }
        }
      }
      if (this.showCyberCdn == true) {
        if (this.cyberBasepriceCdn != '') {
          data.cdnCost.basePrice = this.cyberBasepriceCdn;
        } else {
          data.cdnCost.basePrice = '';
          data.CdnMarkedUpSellingPrice.basePrice = '';
        }
        if (this.cyberUserCdn != '') {
          data.cdnCost.user = this.cyberUserCdn;
        } else {
          data.cdnCost.user = '';
          data.CdnMarkedUpSellingPrice.user = '';
        }
        if (this.cyberDeviceCdn != '') {
          data.cdnCost.device = this.cyberDeviceCdn;
        } else {
          data.cdnCost.device = '';
          data.CdnMarkedUpSellingPrice.device = '';
        }
      }
      data.Usd.IsDevice = this.cyberDeviceUsd != '' ? 'YES' : 'NO';
      data.Usd.IsUser = this.cyberUserUsd != '' ? 'YES' : 'NO';
      data.Usd.IsBasePrice = this.cyberbasepriceUsd != '' ? 'YES' : 'NO';
      data.cdnCost.IsDevice = this.cyberDeviceCdn != '' ? 'YES' : 'NO';
      data.cdnCost.IsUser = this.cyberUserCdn != '' ? 'YES' : 'NO';
      data.cdnCost.IsBasePrice = this.cyberBasepriceCdn != '' ? 'YES' : 'NO';
      data.CdnMarkedUpSellingPrice.basePrice = '$' + (parseFloat(data.cdnCost.basePrice != '' ? data.cdnCost.basePrice.slice(1).replace(/  |,/gi,"") : '0') * markupTool).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      data.CdnMarkedUpSellingPrice.user = '$' + (parseFloat(data.cdnCost.user != '' ? data.cdnCost.user.slice(1).replace(/  |,/gi,"") : '0') * markupTool).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      data.CdnMarkedUpSellingPrice.device = '$' + (parseFloat(data.cdnCost.device != '' ? data.cdnCost.device.slice(1).replace(/  |,/gi,"") : '0') * markupTool).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      this.priceListTableService.priceList.CyberTools.push(data);
      this.viewCtrl.dismiss();
      this.cyberName = '';
      this.cyberDescription = '';
      // }
      // }
    } else if (tableName == 'ADDITIONAL') {
      var markupTool = 1 + parseInt(this.priceListTableService.priceList.TotalToolsMarkup != '' ? this.priceListTableService.priceList.TotalToolsMarkup.slice(0, -1) : '0') / 100;
      let obj = JSON.stringify(this.priceListTableService.priceList.newAdditionalTools);
      var data = JSON.parse(obj);
      data.name = this.additionalName;
      data.description = this.additionalDescription;
      if (this.showAdditionalUsd == true) {
        if (this.showAdditionalUserUsd == true) {
          if (this.additionalUserUsd != '') {
            data.Usd.user = this.additionalUserUsd;
            let cdnUser = (parseFloat(data.Usd.user.slice(1).replace(/  |,/gi,"")) * (1 + (parseFloat(this.priceListTableService.priceList.TotalUsExchange.slice(0, -1)) / 100)));
            data.cdnCost.user = '$' + cdnUser.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
          } else {
            data.Usd.user = '';
            data.cdnCost.user = '';
            data.CdnMarkedUpSellingPrice.user = '';
          }
        } else if (this.showAdditionalBasepriceUsd == true) {
          if (this.additionalbasepriceUsd != '') {
            data.Usd.basePrice = this.additionalbasepriceUsd;
            let cdnBaseprice = (parseFloat(data.Usd.basePrice.slice(1).replace(/  |,/gi,"")) * (1 + (parseFloat(this.priceListTableService.priceList.TotalUsExchange.slice(0, -1)) / 100)));
            data.cdnCost.basePrice = '$' + cdnBaseprice.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
          } else {
            data.cdnCost.basePrice = '';
            data.CdnMarkedUpSellingPrice.basePrice = '';
          }
        } else if (this.showAdditionalDeviceUsd == true) {
          if (this.additionalDeviceUsd != '') {
            data.Usd.device = this.additionalDeviceUsd;
            let cdnDevice = (parseFloat(data.Usd.device.slice(1).replace(/  |,/gi,"")) * (1 + (parseFloat(this.priceListTableService.priceList.TotalUsExchange.slice(0, -1)) / 100)));
            data.cdnCost.device = '$' + cdnDevice.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
          } else {
            data.Usd.device = '';
            data.cdnCost.device = '';
            data.CdnMarkedUpSellingPrice.device = '';
          }
        }
      }
      if (this.showAdditionalCdn == true) {
        if (this.additionalBasepriceCdn != '') {
          data.cdnCost.basePrice = this.additionalBasepriceCdn;
        } else {
          data.cdnCost.basePrice = '';
          data.CdnMarkedUpSellingPrice.basePrice = '';
        }
        if (this.additionalUserCdn != '') {
          data.cdnCost.user = this.additionalUserCdn;
        } else {
          data.cdnCost.user = '';
          data.CdnMarkedUpSellingPrice.user = '';
        }
        if (this.additionalDeviceCdn != '') {
          data.cdnCost.device = this.additionalDeviceCdn;
        } else {
          data.cdnCost.device = '';
          data.CdnMarkedUpSellingPrice.device = '';
        }
      }
      data.Usd.IsDevice = this.additionalDeviceUsd != '' ? 'YES' : 'NO';
      data.Usd.IsUser = this.additionalUserUsd != '' ? 'YES' : 'NO';
      data.Usd.IsBasePrice = this.additionalbasepriceUsd != '' ? 'YES' : 'NO';
      data.cdnCost.IsDevice = this.additionalDeviceCdn != '' ? 'YES' : 'NO';
      data.cdnCost.IsUser = this.additionalUserCdn != '' ? 'YES' : 'NO';
      data.cdnCost.IsBasePrice = this.additionalBasepriceCdn != '' ? 'YES' : 'NO';
      data.CdnMarkedUpSellingPrice.basePrice = '$' + (parseFloat(data.cdnCost.basePrice != '' ? data.cdnCost.basePrice.slice(1).replace(/  |,/gi,"") : '0') * markupTool).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      data.CdnMarkedUpSellingPrice.user = '$' + (parseFloat(data.cdnCost.user != '' ? data.cdnCost.user.slice(1).replace(/  |,/gi,"") : '0') * markupTool).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      data.CdnMarkedUpSellingPrice.device = '$' + (parseFloat(data.cdnCost.device != '' ? data.cdnCost.device.slice(1).replace(/  |,/gi,"") : '0') * markupTool).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      this.priceListTableService.priceList.AdditionalTools.push(data);
      this.viewCtrl.dismiss();
      this.additionalName = '';
      this.additionalDescription = '';
    }
  }
  clickRadio(event, radioName) {
    if (radioName == 'IT_USER') {
      this.showUserCdn = true;
      this.showDeviceCdn = false;
    } else if (radioName == 'IT_DEVICE') {
      this.showUserCdn = false;
      this.showDeviceCdn = true;
    }
    else if (radioName == 'CYBER_USD') {
      this.showCyberUsd = true;
      this.showCyberCdn = false;
    }
    else if (radioName == 'CYBER_CDN') {
      this.showCyberUsd = false;
      this.showCyberCdn = true;
    }
    else if (radioName == 'ADDITIONAL_USD') {
      this.showAdditionalCdn = false;
      this.showAdditionalUsd = true;
    }
    else if (radioName == 'ADDITIONAL_CDN') {
      this.showAdditionalUsd = false;
      this.showAdditionalCdn = true;
    }
  }
  clickInsideRadio(event, radioName) {
    if (radioName == 'CYBER_USD_BASEPRICE') {
      this.showCyberUserUsd = false;
      this.showCyberDeviceUsd = false;
      this.showCyberBasepriceUsd = true;
    } else if (radioName == 'CYBER_USD_USER') {
      this.showCyberUserUsd = true;
      this.showCyberDeviceUsd = false;
      this.showCyberBasepriceUsd = false;
    }
    else if (radioName == 'CYBER_USD_DEVICE') {
      this.showCyberUserUsd = false;
      this.showCyberDeviceUsd = true;
      this.showCyberBasepriceUsd = false;
    } else if (radioName == 'ADDITIONAL_USD_BASEPRICE') {
      this.showAdditionalUserUsd = false;
      this.showAdditionalDeviceUsd = false;
      this.showAdditionalBasepriceUsd = true;
    } else if (radioName == 'ADDITIONAL_USD_USER') {
      this.showAdditionalUserUsd = true;
      this.showAdditionalDeviceUsd = false;
      this.showAdditionalBasepriceUsd = false;
    }
    else if (radioName == 'ADDITIONAL_USD_DEVICE') {
      this.showAdditionalUserUsd = false;
      this.showAdditionalDeviceUsd = true;
      this.showAdditionalBasepriceUsd = false;
    }
  }
  defaultCostCdn(event, tableName) {
    if (tableName == 'CLOUD_SERVER') {
      if (event.target.value != '') {
        if (event.target.value.includes("$") == true) {
          this.defCost = '$' + parseFloat(event.target.value.slice(1).replace(/  |,/gi,"")).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        } else {
          this.defCost = '$' + parseFloat(event.target.value).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        }
      } else {
        this.defCost = ''
      }
    } else if (tableName == 'DATTO_BASE') {
      if (event.target.value != '') {
        if (event.target.value.includes("$") == true) {
          this.dattoDefBase = '$' + parseFloat(event.target.value.slice(1).replace(/  |,/gi,"")).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        } else {
          this.dattoDefBase = '$' + parseFloat(event.target.value).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        }
      } else {
        this.dattoDefBase = ''
      }
    } else if (tableName == 'DATTO_MONTHLY') {
      if (event.target.value != '') {
        if (event.target.value.includes("$") == true) {
          this.dattoDefMonthly = '$' + parseFloat(event.target.value.slice(1).replace(/  |,/gi,"")).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        } else {
          this.dattoDefMonthly = '$' + parseFloat(event.target.value).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        }
      } else {
        this.dattoDefMonthly = ''
      }
    } else if (tableName == 'INTRONIS_USD') {
      if (event.target.value != '') {
        if (event.target.value.includes("$") == true) {
          this.intronisDefUsd = '$' + parseFloat(event.target.value.slice(1).replace(/  |,/gi,"")).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        } else {
          this.intronisDefUsd = '$' + parseFloat(event.target.value).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        }
      } else {
        this.intronisDefUsd = ''
      }
    } else if (tableName == 'IT_BASEPRICE') {
      if (event.target.value != '') {
        if (event.target.value.includes("$") == true) {
          this.itCdnBasePrice = '$' + parseFloat(event.target.value.slice(1).replace(/  |,/gi,"")).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        } else {
          this.itCdnBasePrice = '$' + parseFloat(event.target.value).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        }
      } else {
        this.itCdnBasePrice = ''
      }
    } else if (tableName == 'IT_USER_CDN') {
      if (event.target.value != '') {
        if (event.target.value.includes("$") == true) {
          this.itUserCdn = '$' + parseFloat(event.target.value.slice(1).replace(/  |,/gi,"")).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        } else {
          this.itUserCdn = '$' + parseFloat(event.target.value).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        }
        this.itDeviceCdn = ''
      } else {
        this.itUserCdn = ''
      }
    } else if (tableName == 'IT_DEVICE_CDN') {
      if (event.target.value != '') {
        if (event.target.value.includes("$") == true) {
          this.itDeviceCdn = '$' + parseFloat(event.target.value.slice(1).replace(/  |,/gi,"")).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        } else {
          this.itDeviceCdn = '$' + parseFloat(event.target.value).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        }
        this.itUserCdn = ''
      } else {
        this.itDeviceCdn = ''
      }
    } else if (tableName == 'CYBER_USER_CDN') {
      if (event.target.value != '') {
        if (event.target.value.includes("$") == true) {
          this.cyberUserCdn = '$' + parseFloat(event.target.value.slice(1).replace(/  |,/gi,"")).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        } else {
          this.cyberUserCdn = '$' + parseFloat(event.target.value).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        }
      } else {
        this.cyberUserCdn = ''
      }
    } else if (tableName == 'CYBER_DEVICE_CDN') {
      if (event.target.value != '') {
        if (event.target.value.includes("$") == true) {
          this.cyberDeviceCdn = '$' + parseFloat(event.target.value.slice(1).replace(/  |,/gi,"")).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        } else {
          this.cyberDeviceCdn = '$' + parseFloat(event.target.value).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        }
      } else {
        this.cyberDeviceCdn = ''
      }
    } else if (tableName == 'CYBER_BASEPRICE_CDN') {
      if (event.target.value != '') {
        if (event.target.value.includes("$") == true) {
          this.cyberBasepriceCdn = '$' + parseFloat(event.target.value.slice(1).replace(/  |,/gi,"")).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        } else {
          this.cyberBasepriceCdn = '$' + parseFloat(event.target.value).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        }
      } else {
        this.cyberBasepriceCdn = ''
      }
    } else if (tableName == 'CYBER_USER_USD') {
      if (event.target.value != '') {
        if (event.target.value.includes("$") == true) {
          this.cyberUserUsd = '$' + parseFloat(event.target.value.slice(1).replace(/  |,/gi,"")).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        } else {
          this.cyberUserUsd = '$' + parseFloat(event.target.value).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        }
        this.cyberDeviceUsd = '';
        this.cyberbasepriceUsd = '';
      } else {
        this.cyberUserUsd = ''
      }
    } else if (tableName == 'CYBER_DEVICE_USD') {
      if (event.target.value != '') {
        if (event.target.value.includes("$") == true) {
          this.cyberDeviceUsd = '$' + parseFloat(event.target.value.slice(1).replace(/  |,/gi,"")).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        } else {
          this.cyberDeviceUsd = '$' + parseFloat(event.target.value).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        }
        this.cyberUserUsd = '';
        this.cyberbasepriceUsd = '';
      } else {
        this.cyberDeviceUsd = ''
      }
    } else if (tableName == 'CYBER_BASEPRICE_USD') {
      if (event.target.value != '') {
        if (event.target.value.includes("$") == true) {
          this.cyberbasepriceUsd = '$' + parseFloat(event.target.value.slice(1).replace(/  |,/gi,"")).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        } else {
          this.cyberbasepriceUsd = '$' + parseFloat(event.target.value).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        }
        this.cyberUserUsd = '';
        this.cyberDeviceUsd = '';
      } else {
        this.cyberbasepriceUsd = ''
      }
    } else if (tableName == 'ADDITIONAL_USER_USD') {
      if (event.target.value != '') {
        if (event.target.value.includes("$") == true) {
          this.additionalUserUsd = '$' + parseFloat(event.target.value.slice(1).replace(/  |,/gi,"")).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        } else {
          this.additionalUserUsd = '$' + parseFloat(event.target.value).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        }
        this.additionalDeviceUsd = '';
        this.additionalbasepriceUsd = '';
      } else {
        this.additionalUserUsd = ''
      }
    } else if (tableName == 'ADDITIONAL_DEVICE_USD') {
      if (event.target.value != '') {
        if (event.target.value.includes("$") == true) {
          this.additionalDeviceUsd = '$' + parseFloat(event.target.value.slice(1).replace(/  |,/gi,"")).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        } else {
          this.additionalDeviceUsd = '$' + parseFloat(event.target.value).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        }
        this.additionalUserUsd = '';
        this.additionalbasepriceUsd = '';
      } else {
        this.additionalDeviceUsd = ''
      }
    } else if (tableName == 'ADDITIONAL_BASEPRICE_USD') {
      if (event.target.value != '') {
        if (event.target.value.includes("$") == true) {
          this.additionalbasepriceUsd = '$' + parseFloat(event.target.value.slice(1).replace(/  |,/gi,"")).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        } else {
          this.additionalbasepriceUsd = '$' + parseFloat(event.target.value).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        }
        this.additionalUserUsd = '';
        this.additionalDeviceUsd = '';
      } else {
        this.additionalbasepriceUsd = ''
      }
    } else if (tableName == 'ADDITIONAL_DEVICE_CDN') {
      if (event.target.value != '') {
        if (event.target.value.includes("$") == true) {
          this.additionalDeviceCdn = '$' + parseFloat(event.target.value.slice(1).replace(/  |,/gi,"")).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        } else {
          this.additionalDeviceCdn = '$' + parseFloat(event.target.value).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        }
      } else {
        this.additionalDeviceCdn = ''
      }
    } else if (tableName == 'ADDITIONAL_USER_CDN') {
      if (event.target.value != '') {
        if (event.target.value.includes("$") == true) {
          this.additionalUserCdn = '$' + parseFloat(event.target.value.slice(1).replace(/  |,/gi,"")).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        } else {
          this.additionalUserCdn = '$' + parseFloat(event.target.value).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        }
      } else {
        this.additionalUserCdn = ''
      }
    } else if (tableName == 'ADDITIONAL_BASEPRICE_CDN') {
      if (event.target.value != '') {
        if (event.target.value.includes("$") == true) {
          this.additionalBasepriceCdn = '$' + parseFloat(event.target.value.slice(1).replace(/  |,/gi,"")).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        } else {
          this.additionalBasepriceCdn = '$' + parseFloat(event.target.value).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        }
      } else {
        this.additionalBasepriceCdn = ''
      }
    }
  }
  checkboxClick(event, checkboxName) {
    if (checkboxName == 'CYBER_CDN_BASEPRICE') {
      this.showCyberBasepriceCdn = true;
    } else if (checkboxName == 'CYBER_CDN_USER') {
      this.showCyberUserCdn = true;
    } else if (checkboxName == 'CYBER_CDN_DEVICE') {
      this.showCyberDeviceCdn = true;
    } else if (checkboxName == 'ADDITIONAL_CDN_BASEPRICE') {
      this.showAdditionalBasepriceCdn = true;
    } else if (checkboxName == 'ADDITIONAL_CDN_USER') {
      this.showAdditionalUserCdn = true;
    } else if (checkboxName == 'ADDITIONAL_CDN_DEVICE') {
      this.showAdditionalDeviceCdn = true;
    }
  }

  close(){
    this.viewCtrl.dismiss({
    });
  }
  SelectList(i){
    if(this.rowIndex != undefined){
      document.getElementById('selectedCt'+this.rowIndex).classList.remove('selectedRow');
    }
    const ele = document.getElementById("list"+i) as HTMLInputElement;
    if(ele.checked == true){
      document.getElementById('selectedCt'+i).classList.add('selectedRow');
      this.rowIndex = i;
    }
  }
  submitContract(){
    if(this.rowIndex != undefined){
        this.dataService.ProposalTable = JSON.parse(this.listOfContracts[this.rowIndex].jsonData);
        localStorage.setItem("AllDatto", JSON.stringify(this.dataService.ProposalTable.AllDatto));
        localStorage.setItem("AllIntronis", JSON.stringify(this.dataService.ProposalTable.AllIntronis));
        localStorage.setItem("BackupDrAllDatto", JSON.stringify(this.dataService.ProposalTable.BackupDrAllDatto));
        localStorage.setItem("BackupDrAllIntronis", JSON.stringify(this.dataService.ProposalTable.BackupDrAllIntronis));
        localStorage.setItem("MSPForm", JSON.stringify(this.dataService.ProposalTable.mspForm));
        localStorage.setItem('MSPScreenData', JSON.stringify(this.dataService.ProposalTable.mspPricingSheet));
        localStorage.setItem('CYBERScreenData', JSON.stringify(this.dataService.ProposalTable.cyberPricingSheet));
        localStorage.setItem('CLOUDScreenData', JSON.stringify(this.dataService.ProposalTable.cloudPricingSheet));
        localStorage.setItem('BACKUPDRsScreenData', JSON.stringify(this.dataService.ProposalTable.backupDrPricingSheet));
        localStorage.setItem('HWSWScreenData', JSON.stringify(this.dataService.ProposalTable.hwswHaasSaasSheet));
        localStorage.setItem('ProjectScreen', JSON.stringify(this.dataService.ProposalTable.projectScreen));
        var pricelistData = this.listOfPricelist.filter(element => element.CONTRACT_ID == this.listOfContracts[this.rowIndex].contract_file_1_Id);
        if(pricelistData.length == 1){
          let data = JSON.parse(pricelistData[0].JSON_DATA);
          localStorage.setItem('Pricelist', JSON.stringify(data));
        }
        this.viewCtrl.dismiss({
        })
    }else{
      const toast = this.toastController.create({
        message: 'Please Select any Contract',
        duration: 3000,
      });
      toast.present();
    }
  }
  submitPricelist(){
    if(this.rowIndex != undefined){
    localStorage.removeItem('Pricelist');
    this.priceListTableService.priceList = JSON.parse(this.configApiService.pricelistMaster[this.rowIndex].jsonData);
    this.priceListTableService.pricelistCalculation();
    localStorage.setItem('Pricelist', JSON.stringify(this.priceListTableService.priceList));
    this.dataService.broadcastInfo({ src: 'proposal-create', event: 'SCREEN_CALCULATION', status: true});
    this.priceListTableService.pricelistID = this.configApiService.pricelistMaster[this.rowIndex].Pricelist_Master_1_Id;
    this.priceListTableService.pricelistVersionName = this.configApiService.pricelistMaster[this.rowIndex].versions;
    this.viewCtrl.dismiss({
    });
    this.dataService.broadcastInfo({ src: 'proposal-create', event: 'PAGE_HEADER_VALUE', params: ''});
    }else{
      const toast = this.toastController.create({
        message: 'Please Select any Pricelist',
        duration: 3000,
      });
      toast.present();
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/modal-popup/modal-popup.ts